import { defineComponent as _defineComponent } from 'vue'
import { resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, computed, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import StatisticsCards from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import type { StatisticsCardItem } from '@/views/dashboard/_components/statistics-cards/statistics-cards.vue'
import { VulnerabilityFixService } from '../../vulnerability-fix.service'

type LeakSummaryDrilldownPayload =
  | { kind: 'terminal-high-risk' }
  | { kind: 'leak-list'; warnLevel: 1 | 2 }

type LeakSummaryShape = {
  high_risk_terminal_count: number
  high_risk_count: number
  optional_count: number
}

/** 与卡片顺序对齐：取数、 payload（对齐 examination 页配置表写法，避免 index 链式 if） */

export default /*#__PURE__*/_defineComponent({
  __name: 'leak-summary-cards',
  emits: ["drilldown"],
  setup(__props, { emit: __emit }) {

const LEAK_SUMMARY_CARD_CONFIG = [
  {
    labelKey: 'safeProtectionModule.summaryHighRiskTerminal',
    getCount: (s: LeakSummaryShape) => s.high_risk_terminal_count,
    getDrilldown: (): LeakSummaryDrilldownPayload => ({ kind: 'terminal-high-risk' }),
  },
  {
    labelKey: 'safeProtectionModule.summaryHighRiskLeak',
    getCount: (s: LeakSummaryShape) => s.high_risk_count,
    getDrilldown: (): LeakSummaryDrilldownPayload => ({ kind: 'leak-list', warnLevel: 2 }),
  },
  {
    labelKey: 'safeProtectionModule.summaryOptionalLeak',
    getCount: (s: LeakSummaryShape) => s.optional_count,
    getDrilldown: (): LeakSummaryDrilldownPayload => ({ kind: 'leak-list', warnLevel: 1 }),
  },
] as const

const injector = useReflectiveInjector([VulnerabilityFixService])
const service = injector.get(VulnerabilityFixService)
const { t } = useI18n()

const emit = __emit

const isLoading = ref(false)
const summaryData = ref({
  high_risk_terminal_count: 0,
  high_risk_count: 0,
  optional_count: 0,
})

const cardItems = computed<StatisticsCardItem[]>(() => {
  const s = summaryData.value
  return LEAK_SUMMARY_CARD_CONFIG.map((cfg) => {
    const value = cfg.getCount(s)
    return {
      label: t(cfg.labelKey),
      value,
      clickable: value > 0,
      events: {
        click: () => {
          cfg.getCount(summaryData.value) > 0 && emit('drilldown', cfg.getDrilldown())
        },
      },
    }
  })
})

function loadData () {
  isLoading.value = true
  service.getTeamLeakStat().then((res) => {
    summaryData.value = {
      high_risk_terminal_count: res.high_risk_terminal_count || 0,
      high_risk_count: res.high_risk_count || 0,
      optional_count: res.optional_count || 0,
    }
  }).finally(() => {
    isLoading.value = false
  })
}

onMounted(() => {
  loadData()
})

return (_ctx: any,_cache: any) => {
  const _directive_loading = _resolveDirective("loading")!

  return _withDirectives((_openBlock(), _createBlock(StatisticsCards, { items: cardItems.value }, null, 8, ["items"])), [
    [_directive_loading, isLoading.value]
  ])
}
}

})